import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type AuroraOutcomeValuesProps = {
	name: "pass" | "pending_review" | "fail";
	value: number;
	displayName: string;
};

type ExperianOwnerAuroraOutcomeFieldMutation = {
	id: string;
	values: AuroraOutcomeValuesProps;
	ownerType?: string;
	onSuccessHandler?: Function;
};

const useExperianOwnerAuroraOutcomeFieldMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id, values, ownerType }: ExperianOwnerAuroraOutcomeFieldMutation) =>
			autoChecklistService.setExperianOwnerAuroraOutcome({
				applicationId: id,
				auroraOutcome: values?.name,
				ownerType,
			}),
		{
			onSuccess(_data, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Field has been updated successfully",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useExperianOwnerAuroraOutcomeFieldMutation;
